 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"d525e956674043587278f94fe58048b28c86bb23","2":"e314f57d80def12be12fc149c05d4261b93c2d6b","3":"cc6ce779ea7eb475512d63aa3a5656435d8af8c6","4":"a948c4b57478bbea167580ee0f0109d69a1d352d","5":"863e7df11bba3a0ef1ef6d8d5da584d5841038b3","6":"389e5d776069cdd74a31bfa1cbed11025bdbdd69","7":"498846ab1a725519e75ba19c9d7f19f547dda9eb","8":"70d0308f11c955b21059b2720d12b1e828aa0cc5","9":"b7538928deb198c5eb4df3decc05294dd5646b77","10":"3667ecfd9eb5f3e9cda355bb49bd036c57ae63a1","11":"acca03c814ea8908bf7c0581c81c40c0a3f1702b","12":"48acffcc8dc1fba5ad06e2b7b3284fabea756478","13":"55bde86b65a57b8a835981f355eb5cd15f46b9ff","14":"5b1593547574144ffcaf4382b95988c9b69ea8a0","15":"component---src-pages-home-index-js","19":"component---src-pages-ablauf-index-js","20":"component---src-pages-agb-index-js","21":"component---src-pages-altmetall-kaufen-index-js","22":"component---src-pages-aluminiumpreis-index-js","23":"component---src-pages-anfrage-index-js","24":"component---src-pages-batteriepreise-index-js","25":"component---src-pages-bleipreise-index-js","26":"component---src-pages-disclaimer-index-js","27":"component---src-pages-edelstahlpreis-index-js","28":"component---src-pages-eisenpreise-index-js","29":"component---src-pages-elektroschrottpreise-index-js","30":"component---src-pages-hartmetallpreis-index-js","31":"component---src-pages-impressum-index-js","32":"component---src-pages-index-js","33":"component---src-pages-kabelpreise-index-js","34":"component---src-pages-kupferpreis-index-js","35":"component---src-pages-legierungenpreis-index-js","36":"component---src-pages-marktdaten-disclaimer-js","37":"component---src-pages-marktdaten-index-js","38":"component---src-pages-marktdaten-material-js","39":"component---src-pages-messingpreise-index-js","40":"component---src-pages-partner-index-js","41":"component---src-pages-pro-index-js","42":"component---src-pages-schrottpreise-index-js","43":"component---src-pages-sitemap-index-js","44":"component---src-pages-stahlpreise-index-js","45":"component---src-pages-thank-you-index-js","46":"component---src-pages-ueber-uns-index-js","47":"component---src-pages-zinkpreis-index-js","48":"component---src-pages-zinnpreis-index-js","49":"component---src-templates-marktdaten-index-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"3a36b61cf5040d5e849a","2":"705bfcb460e6f9964283","3":"e2bc76935e3f404453d5","4":"d245b973fa4f1171eff0","5":"37841779131be413a656","6":"77ba492e216fb6664b0c","7":"30fe30a7083eb79bfb5d","8":"29929de755aafe00a93a","9":"b66020dee49c912cce2b","10":"5499b57b37392dbd5ec1","11":"1fdaef26743edf1788da","12":"04a85fab46c85673c406","13":"6d995f22f187ff81eea5","14":"84bdb576166dadbe9da7","15":"41294ab33d0e4d5f3c2c","17":"1d7a059e84f56a6804d3","19":"0b685779770034bc30fe","20":"14a3ce0a07cb4fc4a7ce","21":"bd402cde4c4b63df585c","22":"64cd3028f39da4801447","23":"c1a973de743f438f0f64","24":"3b675401edfee5250d1b","25":"90406fcfec6a47007bf5","26":"7e86dd7f7692b70a3b51","27":"77780c863686d0c3f30d","28":"52be21f65ba82e47d2df","29":"e21269cb4765bd6bf049","30":"46faa0d0874b9e1fb6bd","31":"badcedff772ef1591309","32":"8ed692e77dacbdba1d4b","33":"6dd2fd3fa11d45b58370","34":"a249f42d7ed47e4a6dbd","35":"d9a311feae435e062028","36":"42b52b61352a72cce179","37":"3349d6744ea19f5e0d6a","38":"58b3f34f90967f92032c","39":"13fd30e3954cc7476151","40":"936143d78c11b9c06e85","41":"56fa4f43b97440cc9e47","42":"903f3902aab2e8e8f443","43":"d3e0925a0787ceb42f9c","44":"101eea014b4d0a4e0c60","45":"19fb2c08a8272c167b4a","46":"f7d8f032b1be6a127978","47":"abc1cdf8db504ade319f","48":"bb6c3cba38e9d0a78260","49":"7e2a797b801404ed4fa1","52":"cacb6389808499d0f351","53":"18f74c62f50e5213c4ea"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"d525e956674043587278f94fe58048b28c86bb23","2":"e314f57d80def12be12fc149c05d4261b93c2d6b","3":"cc6ce779ea7eb475512d63aa3a5656435d8af8c6","4":"a948c4b57478bbea167580ee0f0109d69a1d352d","5":"863e7df11bba3a0ef1ef6d8d5da584d5841038b3","6":"389e5d776069cdd74a31bfa1cbed11025bdbdd69","7":"498846ab1a725519e75ba19c9d7f19f547dda9eb","8":"70d0308f11c955b21059b2720d12b1e828aa0cc5","9":"b7538928deb198c5eb4df3decc05294dd5646b77","10":"3667ecfd9eb5f3e9cda355bb49bd036c57ae63a1","11":"acca03c814ea8908bf7c0581c81c40c0a3f1702b","12":"48acffcc8dc1fba5ad06e2b7b3284fabea756478","13":"55bde86b65a57b8a835981f355eb5cd15f46b9ff","14":"5b1593547574144ffcaf4382b95988c9b69ea8a0","15":"component---src-pages-home-index-js","19":"component---src-pages-ablauf-index-js","20":"component---src-pages-agb-index-js","21":"component---src-pages-altmetall-kaufen-index-js","22":"component---src-pages-aluminiumpreis-index-js","23":"component---src-pages-anfrage-index-js","24":"component---src-pages-batteriepreise-index-js","25":"component---src-pages-bleipreise-index-js","26":"component---src-pages-disclaimer-index-js","27":"component---src-pages-edelstahlpreis-index-js","28":"component---src-pages-eisenpreise-index-js","29":"component---src-pages-elektroschrottpreise-index-js","30":"component---src-pages-hartmetallpreis-index-js","31":"component---src-pages-impressum-index-js","32":"component---src-pages-index-js","33":"component---src-pages-kabelpreise-index-js","34":"component---src-pages-kupferpreis-index-js","35":"component---src-pages-legierungenpreis-index-js","36":"component---src-pages-marktdaten-disclaimer-js","37":"component---src-pages-marktdaten-index-js","38":"component---src-pages-marktdaten-material-js","39":"component---src-pages-messingpreise-index-js","40":"component---src-pages-partner-index-js","41":"component---src-pages-pro-index-js","42":"component---src-pages-schrottpreise-index-js","43":"component---src-pages-sitemap-index-js","44":"component---src-pages-stahlpreise-index-js","45":"component---src-pages-thank-you-index-js","46":"component---src-pages-ueber-uns-index-js","47":"component---src-pages-zinkpreis-index-js","48":"component---src-pages-zinnpreis-index-js","49":"component---src-templates-marktdaten-index-js"}[chunkId]||chunkId) + "." + {"0":"1d8416ac8a56b1900a97","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
